import React from 'react';
import { useEscapeKey } from '../hooks/useEscapeKey';

const TransactionPromptModal = ({ onConfirm, onCancel }) => {
  useEscapeKey(() => onConfirm(false));
  return (
    <div className="fixed inset-0 bg-gray-500 bg-opacity-75 flex items-center justify-center p-4 z-50">
      <div className="bg-white rounded-lg p-6 max-w-sm w-full">
        <h3 className="text-lg font-medium text-gray-900 mb-4">Create Transaction?</h3>
        <p className="text-sm text-gray-500 mb-4">
          Would you like to create a transaction for the selected coin(s)?
        </p>
        <div className="flex justify-end gap-4">
          <button
            onClick={() => onConfirm(false)}
            className="inline-flex items-center px-4 py-2 border border-gray-300 text-sm font-medium rounded-md text-gray-700 bg-white hover:bg-gray-50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            No
          </button>
          <button
            onClick={() => onConfirm(true)}
            className="inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md text-white bg-indigo-600 hover:bg-indigo-700 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-indigo-500"
          >
            Yes
          </button>
        </div>
      </div>
    </div>
  );
};

export default TransactionPromptModal;
